import rollbar from '@cred/shared/rollbar'
import {LOG_ENTRY_QUERY} from '../graphql/mutations/log-entry'

export default class LogService {
  static error(client, message, versionUuid) {
    console.error(message)
    rollbar.error(message)
    client.mutate({
      mutation: LOG_ENTRY_QUERY,
      variables: {
        message,
        versionUuid
      }
    })
  }
}
